import { render } from "./legalAndRights.vue?vue&type=template&id=7abdb408&scoped=true"
import script from "./legalAndRights.vue?vue&type=script&lang=js"
export * from "./legalAndRights.vue?vue&type=script&lang=js"

import "./legalAndRights.vue?vue&type=style&index=0&id=7abdb408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abdb408"]])

export default __exports__